import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  Filler,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  CategoryScale,
  LinearScale
} from 'chart.js';

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  Filler,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  CategoryScale,
  LinearScale
);

export const CHART_COLORS = {
  primary: '#4f46e5',
  blue: '#3b82f6',
  dark: '#1e293b',
  slate: '#475569',
  lightSlate: '#94a3b8',
  gridLine: '#f1f5f9',
  border: '#e2e8f0',
  bg: '#ffffff',
  palette: ['#4f46e5', '#16a34a', '#ea580c', '#0d9488', '#9333ea', '#d97706', '#e11d48', '#475569']
};
